import { MediaItem } from '../../types';

interface UseEditorActionHandlersProps {
  setMediaItems: React.Dispatch<React.SetStateAction<MediaItem[]>>;
  setAIModalInitialValues: React.Dispatch<React.SetStateAction<any>>;
  setIsAIImageModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  updateMediaItemPosition: (items: MediaItem[], itemId: string, position: { x: number; y: number }) => MediaItem[];
  updateMediaItemScale: (items: MediaItem[], itemId: string, scale: { scaleX: number; scaleY: number }) => MediaItem[];
  showNotification: (notification: any) => void;
}

export const useEditorActionHandlers = ({
  setMediaItems,
  setAIModalInitialValues,
  setIsAIImageModalOpen,
  updateMediaItemPosition,
  updateMediaItemScale,
  showNotification
}: UseEditorActionHandlersProps) => {

  // Media Transform Handlers
  const handleUpdateMediaPosition = (itemId: string, deltaXPercent: number, deltaYPercent: number) => {
    setMediaItems(prevItems => {
      const item = prevItems.find(i => i.id === itemId);
      if (!item) return prevItems;

      const currentPos = item.position || { x: 0, y: 0 };
      const updatedItems = updateMediaItemPosition(prevItems, itemId, {
        x: currentPos.x + deltaXPercent,
        y: currentPos.y + deltaYPercent
      });
      return updatedItems;
    });
  };

  const handleUpdateMediaScale = (itemId: string, scaleDelta: number) => {
    setMediaItems(prevItems => {
      const item = prevItems.find(i => i.id === itemId);
      if (!item) return prevItems;

      const currentScale = item.scale || { scaleX: 1, scaleY: 1 };
      const updatedItems = updateMediaItemScale(prevItems, itemId, {
        scaleX: currentScale.scaleX + scaleDelta,
        scaleY: currentScale.scaleY + scaleDelta
      });
      return updatedItems;
    });
  };

  const handleResetMediaTransform = (itemId: string) => {
    setMediaItems(prevItems => {
      return prevItems.map(item => {
        if (item.id === itemId) {
          const { position, scale, ...rest } = item;
          return rest as MediaItem;
        }
        return item;
      });
    });
    
    showNotification({
      type: 'success',
      title: 'Reset Complete',
      message: 'Media position and scale reset to default'
    });
  };

  // AI Modal Handlers
  const handleOpenAIVideoFromImage = (imageUrl: string, prompt?: string) => {
    setAIModalInitialValues({
      tab: 'video',
      imageUrl: imageUrl,
      prompt: prompt
    });
    setIsAIImageModalOpen(true);
  };

  const handleOpenUpscaleFromVideo = (videoUrl: string) => {
    setAIModalInitialValues({
      tab: 'upscale',
      videoUrl: videoUrl
    });
    setIsAIImageModalOpen(true);
  };

  const handleVideoUpscaled = (result: any) => {
    // showNotification({
    //   title: 'Video Upscaled Successfully',
    //   message: `Your video has been upscaled to 4X resolution!`,
    //   type: 'success'
    // });
    
    console.log('Video upscaled:', result);
  };

  return {
    // Media transform handlers
    handleUpdateMediaPosition,
    handleUpdateMediaScale,
    handleResetMediaTransform,
    // AI modal handlers
    handleOpenAIVideoFromImage,
    handleOpenUpscaleFromVideo,
    handleVideoUpscaled
  };
};
